import React, { useState, useEffect } from 'react';
import { Params } from 'found';

import { makeStyles } from '@material-ui/core/styles';

import { Icon, Translate } from '@hydra/common/components';
import RankedKeywordsTable from '@hydra/common/components/RankedKeywordsTable';
import { getRankedKeywords } from '@hydra/utils/serpApiRequest';
import * as serpSelector from '../modules/serpSelector';

import { RankedKeyword, SerpGeoLocation, SerpProjectKeyword } from '@hydra/types/serp';

const useStyles = makeStyles(theme => ({
  center: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(6)
  },
  table: {
    marginTop: theme.spacing(3)
  },
  label: {
    fontSize: theme.typography.fontSizeLarge,
    fontWeight: theme.typography.fontWeightSemibold,
    marginTop: theme.spacing(4)
  }
}));

interface RankedKeywordsProps {
  keywordsLeft: number
  selectedKeywords: string[]
  selectKeywords: (keyword: string[]) => void
  url: string
  routeParams: Params
  keywords: SerpProjectKeyword[]
  selectedGeoLocation: SerpGeoLocation
}

export default function RankedKeywords (props: RankedKeywordsProps) {
  const classes = useStyles();
  const {
    keywordsLeft,
    selectedKeywords,
    selectKeywords,
    url,
    routeParams,
    keywords,
    selectedGeoLocation
  } = props;

  const [country, language] = routeParams.domain.split('_');
  const currentSearchEngineKeywords = serpSelector.getCurrentSearchEngineKeywords({
    keywords,
    searchEngine: { country, language: language || 'default' },
    geoLocation: selectedGeoLocation
  });
  const [isLoading, setLoading] = useState(true);
  const [rankedKeywords, setRankedKeywords] = useState<RankedKeyword[]>([]);

  const handleGetRankedKeywords = async ({ url, country, language }: { url: string, country: string, language: string | null }) => {
    try {
      const rankedKeywords = await getRankedKeywords({ url, country, language });
      setRankedKeywords(rankedKeywords);
      return setLoading(false);
    } catch (error) {
      setRankedKeywords([]);
      return setLoading(false);
    }
  };

  useEffect(() => {
    const [country, language = null] = routeParams.domain.split('_');
    handleGetRankedKeywords({ url, country, language });
  }, [url, routeParams]);

  const filteredRankedKeywords = rankedKeywords.filter(keyword => {
    return selectedKeywords.indexOf(keyword.keyword) === -1 && currentSearchEngineKeywords.indexOf(keyword.keyword) === -1;
  });

  return (
    <>
      {isLoading
        ? (
          <div className={classes.center}>
            <Icon type='loader' color='primary' />
          </div>
          )
        : filteredRankedKeywords && filteredRankedKeywords.length
          ? (
            <div className={classes.table}>
              <RankedKeywordsTable
                areKeywordsDisabled={selectedKeywords.length >= keywordsLeft}
                rankedKeywords={filteredRankedKeywords}
                onClickKeyword={selectKeywords}
              />
            </div>
            )
          : (
            <>
              <Translate component='div' className={classes.label} content='serp_add_ranked_keywords' />
              <div className={classes.center}>
                <Translate component='p' content='serp_ranked_keywords_not_found' />
              </div>
            </>
            )}
    </>
  );
}
